import { useState, useEffect } from 'react';

const COLORS = ['#16c79a', '#f5a623', '#3b82f6', '#ec4899', '#a78bfa', '#34d399', '#fb923c'];
const SHAPES = ['circle', 'square', 'triangle'];

function randomBetween(a, b) { return a + Math.random() * (b - a); }

export default function Confetti({ trigger, duration = 2000 }) {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (!trigger) return;
    const count = 40;
    const newParticles = Array.from({ length: count }, (_, i) => ({
      id: Date.now() + i,
      x: randomBetween(10, 90),
      color: COLORS[i % COLORS.length],
      shape: SHAPES[i % SHAPES.length],
      size: randomBetween(6, 12),
      delay: randomBetween(0, 400),
      duration: randomBetween(800, 1600),
      drift: randomBetween(-40, 40),
      spin: randomBetween(180, 720),
    }));
    setParticles(newParticles);
    const timer = setTimeout(() => setParticles([]), duration);
    return () => clearTimeout(timer);
  }, [trigger, duration]);

  if (!particles.length) return null;

  return (
    <div className="fixed inset-0 pointer-events-none z-[100] overflow-hidden">
      {particles.map(p => (
        <div
          key={p.id}
          className="absolute"
          style={{
            left: `${p.x}%`,
            top: '-10px',
            width: p.size,
            height: p.size,
            backgroundColor: p.shape !== 'triangle' ? p.color : 'transparent',
            borderRadius: p.shape === 'circle' ? '50%' : p.shape === 'square' ? '2px' : '0',
            borderLeft: p.shape === 'triangle' ? `${p.size / 2}px solid transparent` : undefined,
            borderRight: p.shape === 'triangle' ? `${p.size / 2}px solid transparent` : undefined,
            borderBottom: p.shape === 'triangle' ? `${p.size}px solid ${p.color}` : undefined,
            animation: `confetti-fall ${p.duration}ms ease-out ${p.delay}ms both`,
            '--drift': `${p.drift}px`,
            '--spin': `${p.spin}deg`,
          }}
        />
      ))}
      <style>{`
        @keyframes confetti-fall {
          0% { transform: translateY(0) translateX(0) rotate(0deg) scale(1); opacity: 1; }
          100% { transform: translateY(100vh) translateX(var(--drift)) rotate(var(--spin)) scale(0.5); opacity: 0; }
        }
      `}</style>
    </div>
  );
}
